import { type CurrencyDictionaryResponse_Int32 } from '@acme/api';
import { useEffect, useState } from 'react';
import { currencyStore } from './model';

export const useCurrency = (currencyId?: string) => {
  const [currency, setCurrency] = useState<
    CurrencyDictionaryResponse_Int32 | undefined
  >();
  const [currencies, setCurrencies] = useState<
    CurrencyDictionaryResponse_Int32[]
  >([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<Error | null>(null);

  useEffect(() => {
    const loadCurrency = async () => {
      try {
        setIsLoading(true);
        const currencies = await currencyStore.getCurrencies();

        setCurrencies(currencies);

        if (currencyId) {
          const foundCurrency = currencies.find(
            (c) => c.id === Number(currencyId)
          );
          setCurrency(foundCurrency);
        }
      } catch (err) {
        setError(
          err instanceof Error ? err : new Error('Failed to load currency')
        );
      } finally {
        setIsLoading(false);
      }
    };

    loadCurrency();
  }, [currencyId]);

  return { currency, currencies, isLoading, error };
};

export const useCryptoCurrency = (currencyId?: string) => {
  const [currency, setCurrency] = useState<
    CurrencyDictionaryResponse_Int32 | undefined
  >();
  const [currencies, setCurrencies] = useState<
    CurrencyDictionaryResponse_Int32[]
  >([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<Error | null>(null);

  useEffect(() => {
    const loadCurrency = async () => {
      try {
        setIsLoading(true);
        const currencies = await currencyStore.getCryptoCurrencies();

        setCurrencies(currencies);

        if (currencyId) {
          const foundCurrency = currencies.find(
            (c) => c.id === Number(currencyId)
          );
          setCurrency(foundCurrency);
        }
      } catch (err) {
        setError(
          err instanceof Error ? err : new Error('Failed to load currency')
        );
      } finally {
        setIsLoading(false);
      }
    };

    loadCurrency();
  }, [currencyId]);

  return { currency, currencies, isLoading, error };
};
